import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { BrowserRouter as Router, Route, Link, useLocation } from "react-router-dom";
// import DashboardIcon from "@material-ui/icons/Dashboard";
import DashboardIcon from "../../src/assets/icons/Deshboard.png"
import DashboardIcon2 from "../../src/assets/icons2/Deshboard.png"
import Sales from "../../src/assets/icons/sales.png"
import Service from "../../src/assets/icons/service.png"
import Purchase from "../../src/assets/icons/Purchase.png"
import Manufacturing from "../../src/assets/icons/Manufacturing.png"
import Inventory from "../../src/assets/icons/Inventory.png"
import Accounts from "../../src/assets/icons/Accounts.png"
import Hr from "../../src/assets/icons/Hr& Payroll.png"
import Report from "../../src/assets/icons/Report.png"
import CRM from "../../src/assets/icons/CRM.png"
import Settings from "../../src/assets/icons/Settingpng.png"
import QuotationIcon from "../../src/assets/icons/Qutation.png"
import Pos from "../../src/assets/icons/pos.png"
import search from "../../src/assets/icons/search.png"


import search2 from "../../src/assets/icons2/search.png"
import Pos2 from "../../src/assets/icons2/pos.png"
import Sales2 from "../../src/assets/icons2/sales.png"
import Service2 from "../../src/assets/icons2/service.png"
import Purchase2 from "../../src/assets/icons2/Purchase.png"
import Manufacturing2 from "../../src/assets/icons2/Manufacturing.png"
import Inventory2 from "../../src/assets/icons2/Inventory.png"
import Accounts2 from "../../src/assets/icons2/Accounts.png"
import Hr2 from "../../src/assets/icons2/Hr& Payroll.png"
import Report2 from "../../src/assets/icons2/Report.png"
import CRM2 from "../../src/assets/icons2/CRM.png"
import Settings2 from "../../src/assets/icons2/Setting.png"
import QuotationIcon2 from "../../src/assets/icons2/Qutation.png"





import {
  Drawer,
  AppBar,
  Toolbar,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Badge,
  Fade,
  Divider,
  IconButton,
  BottomNavigation,
  BottomNavigationAction,
  Avatar,
} from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import Button from "@material-ui/core/Button";

import Grid from "@material-ui/core/Grid";
import Autocomplete from "@material-ui/lab/Autocomplete";

import { deepOrange, deepPurple } from "@material-ui/core/colors";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import NotificationsIcon from "@material-ui/icons/Notifications";

import axios from "axios";
import "./global.css";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import TextField from "@material-ui/core/TextField";

import { APP_URL, API_URL } from "../config";
import { accessChecker, pathSpliter } from "../lib/functions";
import socketIOClient from "socket.io-client";
import {
  currentRouteSet,
  createdCategorySet,
  updatedCategorySet,
  disableRestoreSet,
  createdBrandSet,
  updatedBrandSet,
  brandDisableRestoreSet,
  createdFloorSet,
  updatedFloorSet,
  disableRestoreFloorSet,
  createdRackSet,
  updatedRackSet,
  disableRestoreRackSet,
  createdColorSet,
  updatedColorSet,
  disableRestoreColorSet,
  disableRestoreUnitSet,
  updatedUnitSet,
  createdUnitSet,
  createdBranchSet,
  updatedBranchSet,
  disableRestoreBranchSet,
  createdWarehouseSet,
  updatedWarehouseSet,
  disableRestoreWarehouseSet,
  createdAreaSet,
  updatedAreaSet,
  disableRestoreAreaSet,

  createdProdNameSet,
  updatedProdNameSet,
  disableRestoreProdNameSet,

  createdTransportNameSet,
  updatedTransportNameSet,
  disableRestoreTransportNameSet,

  createdDeliveryNameSet,
  updatedDeliveryNameSet,
  disableRestoreDeliveryNameSet,

  createdEmailCcNameSet,
  updatedEmailCcNameSet,
  disableRestoreEmailCcNameSet,

  createdDeliverySet,
  updatedDeliverySet,
  disableRestoreDeliverySet,

  createdProductSet,
  updatedProductSet,
  productCodeSet,
  disableRestoreProductSet,
  customerCodeSet,
  createdMaterialSet,
  updatedMaterialSet,
  materialCodeSet,
  disableRestoreMaterialSet,
  createdCustomerSet,
  updatedCustomerSet,
  disableRestoreCustomerSet,
  createdSupplierSet,
  updatedSupplierSet,
  disableRestoreSupplierSet,
  createdDesignationSet,
  updatedDesignationSet,
  disableRestoreDesignationSet,
  createdDepartmentSet,
  updatedDepartmentSet,
  disableRestoreDepartmentSet,
  createdMonthSet,
  updatedMonthSet,
  disableRestoreMonthSet,
  createdEmployeeSet,
  updatedEmployeeSet,
  employeeDisableRestoreSet,
  employeeCodeSet,
  createdTranAccSet,
  updatedTranAccSet,
  tranAccDisableRestoreSet,
  tranAccCodeSet,
  createdBankAccSet,
  bankAccCodeSet,
  updatedBankAccSet,
  createdCashTranSet,
  updatedCashTranSet,
  cashTranDisableRestoreSet,
  cashTranCodeSet,
  createdBankTranSet,
  updatedBankTranSet,
  bankTranDisableRestoreSet,
  bankTranCodeSet,
  createdCustomerPaySet,
  updatedCustomerPaySet,
  customerPayDisableRestoreSet,
  createdSupplierPaySet,
  updatedSupplierPaySet,
  supplierPayDisableRestoreSet,
  createdMaterialNameSet,
  updatedMaterialNameSet,
  disableRestoreMaterialNameSet,
} from "../actions/actions";
import swal from "sweetalert";

const drawerWidth = 200;
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  drawerIconColor: {
    color: "rgb(255, 255, 255)",
  },
  linkStyle: {
    textDecoration: "none",
    color: "#484848",
    paddingTop: "4px !important",
    paddingBottom: "4px !important",
  },
  crmSidebarPanel: {
    margin: "8px 10px 0",
    padding: "8px",
    borderRadius: "12px",
    background: "linear-gradient(180deg, #0f1630 0%, #0b1330 100%)",
    minHeight: "calc(100vh - 120px)",
    display: "flex",
    flexDirection: "column",
  },
  crmSidebarLink: {
    textDecoration: "none",
    color: "#d1d5db",
    display: "block",
    marginBottom: "8px",
    "&:last-child": {
      marginBottom: 0,
    },
  },
  crmSidebarItem: {
    borderRadius: "10px",
    paddingTop: "8px",
    paddingBottom: "8px",
  },
  crmSidebarItemText: {
    "& .MuiListItemText-primary": {
      fontSize: "18px",
      fontWeight: 500,
      color: "inherit",
    },
  },
  crmSidebarItemActive: {
    background: "linear-gradient(90deg, #3f67f3 0%, #4d5af4 100%)",
    color: "#ffffff",
  },
  appBar: {
    backgroundColor: "#FFFFFF",
    color: theme.topNavApp.color,
    borderBottom: "1px solid #9CE1E7",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    backgroundColor: "#FFFFFF",
    color: theme.topNavApp.color,
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    background: theme.sidebar,
  },
  drawerOpen: {
    width: drawerWidth,
    background: "#FFF1EE",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(0) + 0,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(0) + 0,
    },
  },
  toolbarspace: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
  toolbar: {
    backgroundColor: "#FFFFFF",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  companyTitle: {
    textAlign: "left",
    color: "#568389",
    fontSize: "20px",
  },
  "@global": {
    ".MuiListItem-gutters": {
      paddingLeft: "5px",
      paddingRight: "0px",
    },

    ".MuiTableCell-head:last-child": {
      textAlign: "right",
    },
    ".MuiTableCell-head:first-child": {
      textAlign: "left",
    },

    ".MuiAlert-standardSuccess": {
      color: "#ffff !important",
      fontSize: "15px !important",
      backgroundColor: "green !important",
      fontWeight: "bold !important",
    },

    ".MuiTableCell-root": {
      padding: "1px !important",
    },
    ".MuiTypography-h6": {
      textAlign: "left",
      marginLeft: "-22px",
    },
    // You should target [class*="MuiButton-root"] instead if you nest themes.
    ".MuiBottomNavigation-root": {
      background: "transparent",
    },
    ".MuiListItem-root": {
      paddingBottom: "1px",
      paddingTop: "1px",
    },
    ".MuiListItemIcon-root": {
      minWidth: "30px",
    },
    a: {
      textDecoration: "none",
    },
    ".MuiInputBase-input": {
      width: "100% !important",
    },
    ".MuiButton-containedPrimary": {
      backgroundColor: "#188074 !important",
      color: "#005d1f",
      backgroundColor: "#95f3ff",
    },
    ".MuiButton-containedPrimary:hover": {
      backgroundColor: "#188074 !important",
      color: "#005d1f",
      backgroundColor: "#65da63",
    },
    ".MuiOutlinedInput-input": {
      padding: "10.5px 14px !important",
    },
    ".MuiInputLabel-outlined": {
      zIndex: "1",
      transform: "translate(14px, 13px) scale(1)",
      pointerEvents: "none",
    },
    ".MuiDrawer-paperAnchorLeft": {
      overflowX: "hidden",
    },
    '.MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"]':
    {
      padding: "0px !important",
    },
  },
  usersettingaction: {
    marginLeft: 0,
    cursor: "pointer",
    marginLeft: "15px",
    marginRight: "15px",
  },
  whiteSpace: {
    width: "100%",
  },
  orange: {
    color: theme.palette.getContrastText(deepOrange[500]),
    backgroundColor: deepOrange[500],
  },
  purple: {
    color: theme.palette.getContrastText(deepPurple[500]),
    backgroundColor: deepPurple[500],
  },
}));
const Header = ({
  path,
  menuAction,
  currentRoute,
  currentRouteSet,
  createdCategorySet,
  updatedCategorySet,
  disableRestoreSet,
  createdBrandSet,
  updatedBrandSet,
  brandDisableRestoreSet,
  createdFloorSet,
  updatedFloorSet,
  disableRestoreFloorSet,
  createdRackSet,
  updatedRackSet,
  disableRestoreRackSet,
  createdColorSet,
  updatedColorSet,
  disableRestoreColorSet,
  createdUnitSet,
  updatedUnitSet,
  disableRestoreUnitSet,
  createdBranchSet,
  updatedBranchSet,
  disableRestoreBranchSet,
  createdWarehouseSet,
  updatedWarehouseSet,
  disableRestoreWarehouseSet,
  createdAreaSet,
  updatedAreaSet,
  disableRestoreAreaSet,

  createdDeliveryNameSet,
  updatedDeliveryNameSet,
  disableRestoreDeliveryNameSet,

  createdEmailCcNameSet,
  updatedEmailCcNameSet,
  disableRestoreEmailCcNameSet,

  createdDeliverySet,
  updatedDeliverySet,
  disableRestoreDeliverySet,

  createdProdNameSet,
  updatedProdNameSet,
  disableRestoreProdNameSet,

  createdTransportNameSet,
  updatedTransportNameSet,
  disableRestoreTransportNameSet,

  authInfo,
  createdMaterialNameSet,
  updatedMaterialNameSet,
  disableRestoreMaterialNameSet,
  createdProductSet,
  updatedProductSet,
  productCodeSet,
  disableRestoreProductSet,
  customerCodeSet,
  createdCustomerSet,
  updatedCustomerSet,
  disableRestoreCustomerSet,
  createdSupplierSet,
  updatedSupplierSet,
  disableRestoreSupplierSet,
  createdDesignationSet,
  updatedDesignationSet,
  disableRestoreDesignationSet,
  createdDepartmentSet,
  updatedDepartmentSet,
  disableRestoreDepartmentSet,
  createdMonthSet,
  updatedMonthSet,
  disableRestoreMonthSet,
  createdEmployeeSet,
  updatedEmployeeSet,
  employeeDisableRestoreSet,
  employeeCodeSet,
  createdTranAccSet,
  updatedTranAccSet,
  tranAccDisableRestoreSet,
  tranAccCodeSet,
  createdBankAccSet,
  bankAccCodeSet,
  createdCashTranSet,
  updatedCashTranSet,
  cashTranDisableRestoreSet,
  cashTranCodeSet,
  createdBankTranSet,
  updatedBankTranSet,
  bankTranDisableRestoreSet,
  bankTranCodeSet,
  createdCustomerPaySet,
  updatedCustomerPaySet,
  customerPayDisableRestoreSet,
  createdSupplierPaySet,
  updatedSupplierPaySet,
  supplierPayDisableRestoreSet,
  createdMaterialSet,
  updatedMaterialSet,
  materialCodeSet,
  disableRestoreMaterialSet,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const location = useLocation();
  const [open, setOpen] = React.useState(true);
  const [value, setValue] = React.useState(0);
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openusersetting = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [branchSwitch, branchSwitchSet] = React.useState(false);
  const [branches, branchesSet] = React.useState([]);
  const [selectedBranch, selectedBranchSet] = React.useState(null);
  const [user_password, user_password_set] = React.useState("");
  let [ajaxReqStatus, ajaxReqStatusSet] = useState(false);

  const logout = () => {
    sessionStorage.clear();
    window.location.href = `${APP_URL}`;
  };

  useEffect(() => {
    currentRouteSet(pathSpliter(location.pathname, 1));
  }, [location.pathname, currentRouteSet]);

  const crmDashboardActive = location.pathname === "/crm/dashboard";
  const crmReportsActive = location.pathname === "/crm/crm-reports";
  const crmSalespeopleActive = location.pathname === "/crm/salespeople";
  const crmCustomersActive = location.pathname === "/crm/customers";
  const crmFollowupsActive = location.pathname === "/crm/follow_ups";

  useEffect(() => {
    const socket = socketIOClient(API_URL);

    socket.on("accessChanged", (data) => {
      console.log(authInfo.userInfo.user_id, " -- ", data.user_id);
      if (
        data.access == "changed" &&
        authInfo.userInfo.user_id == data.user_id
      ) {
        swal({
          title: data.msg,
          icon: "warning",
        }).then((res) => {
          if (res) {
            logout();
          } else {
            logout();
          }
        });
      }
    });

    // Supplier payments
    socket.on("createdSupplierPay", (data) => {
      createdSupplierPaySet(data);
    });

    socket.on("updatedSupplierPay", (data) => {
      updatedSupplierPaySet(data);
    });
    socket.on("disableRestoreSupplierPay", (data) => {
      supplierPayDisableRestoreSet(data);
    });

    // Bank Accounts time
    socket.on("createdBankAcc", (data) => {
      createdBankAccSet(data);
    });

    socket.on("bankAccCode", (data) => {
      bankAccCodeSet(data);
    });

    socket.on("updatedBankAcc", (data) => {
      updatedBankAccSet(data);
    });

    // Transaction Accounts real time
    socket.on("createdTranAcc", (data) => {
      createdTranAccSet(data);
    });

    socket.on("updatedTranAcc", (data) => {
      updatedTranAccSet(data);
    });
    socket.on("disableRestoreTranAcc", (data) => {
      tranAccDisableRestoreSet(data);
    });

    socket.on("disableRestoreCashTranAcc", (data) => {
      cashTranDisableRestoreSet(data);
    });

    socket.on("tranAccCode", (data) => {
      tranAccCodeSet(data);
    });
    //  category real time
    socket.on("createdCategory", (data) => {
      createdCategorySet(data);
    });

    socket.on("updatedCategory", (data) => {
      updatedCategorySet(data);
    });
    socket.on("disableRestoreCategory", (data) => {
      disableRestoreSet(data);
    });
    //  Employee real time
    socket.on("createdEmployee", (data) => {
      createdEmployeeSet(data);
    });
    socket.on("updatedEmployee", (data) => {
      updatedEmployeeSet(data);
    });
    socket.on("disableRestoreEmployee", (data) => {
      employeeDisableRestoreSet(data);
    });
    socket.on("employeeCode", (data) => {
      employeeCodeSet(data);
    });
    //  Brand real time
    socket.on("createdBrand", (data) => {
      createdBrandSet(data);
    });
    socket.on("updatedBrand", (data) => {
      updatedBrandSet(data);
    });
    socket.on("disableRestoreBrand", (data) => {
      brandDisableRestoreSet(data);
    });
    //Floor real time
    socket.on("createdFloor", (data) => {
      createdFloorSet(data)
    })
    socket.on("updatedFloor", (data) => {
      updatedFloorSet(data)
    })
    socket.on("disableRestoreFloor", (data) => {
      disableRestoreFloorSet(data)
    })
    //Rack real time
    socket.on("createdRack", (data) => {
      createdRackSet(data)
    })
    socket.on("updatedRack", (data) => {
      updatedRackSet(data)
    })
    socket.on("disableRestoreRack", (data) => {
      disableRestoreRackSet(data)
    })
    // Color real time
    socket.on("createdColor", (data) => {
      createdColorSet(data);
    });
    socket.on("updatedColor", (data) => {
      updatedColorSet(data);
    });
    socket.on("disableRestoreColor", (data) => {
      disableRestoreColorSet(data);
    });
    // Unit real time
    socket.on("createdUnit", (data) => {
      createdUnitSet(data);
    });
    socket.on("updatedUnit", (data) => {
      updatedUnitSet(data);
    });
    socket.on("disableRestoreUnit", (data) => {
      disableRestoreUnitSet(data);
    });
    // Branch real time
    socket.on("createdBranch", (data) => {
      createdBranchSet(data);
    });
    socket.on("updatedBranch", (data) => {
      updatedBranchSet(data);
    });
    socket.on("disableRestoreBranch", (data) => {
      disableRestoreBranchSet(data);
    });
    // Warehouse real time
    socket.on("createdWarehouse", (data) => {
      createdWarehouseSet(data);
    });
    socket.on("updatedWarehouse", (data) => {
      updatedWarehouseSet(data);
    });
    socket.on("disableRestoreWarehouse", (data) => {
      disableRestoreWarehouseSet(data);
    });
    // Area real time
    socket.on("createdArea", (data) => {
      createdAreaSet(data);
    });
    socket.on("updatedArea", (data) => {
      updatedAreaSet(data);
    });
    socket.on("disableRestoreArea", (data) => {
      disableRestoreAreaSet(data);
    });

    // delivery name 
    socket.on("createdDeliveryName", (data) => {
      createdDeliveryNameSet(data);
    });

    socket.on("updatedDeliveryName", (data) => {
      updatedDeliveryNameSet(data);
    });

    socket.on("disableRestoreDeliveryName", (data) => {
      disableRestoreDeliveryNameSet(data);
    });

    // email cc
    socket.on("createdEmailCcName", (data) => {
      createdEmailCcNameSet(data);
    });

    socket.on("updatedEmailCcName", (data) => {
      updatedEmailCcNameSet(data);
    });

    socket.on("disableRestoreEmailCcName", (data) => {
      disableRestoreEmailCcNameSet(data);
    });


    // delivery 
    socket.on("createdDelivery", (data) => {
      createdDeliverySet(data);
    });

    socket.on("updatedDelivery", (data) => {
      updatedDeliverySet(data);
    });

    socket.on("disableRestoreDelivery", (data) => {
      disableRestoreDeliverySet(data);
    });

    // Product name real time
    socket.on("createdProdName", (data) => {
      createdProdNameSet(data);
    });

    socket.on("updatedPordName", (data) => {
      updatedProdNameSet(data);
    });

    socket.on("disableRestoreProdName", (data) => {
      disableRestoreProdNameSet(data);
    });

    // transport name real time 
    socket.on("createdTransportName", (data) => {
      createdTransportNameSet(data);
    });

    socket.on("updatedTransportName", (data) => {
      updatedTransportNameSet(data);
    });

    socket.on("disableRestoreTransportName", (data) => {
      disableRestoreTransportNameSet(data);
    });



    // Product name real time
    socket.on("createdMaterialName", (data) => {
      createdMaterialNameSet(data);
    });
    socket.on("updatedMaterialName", (data) => {
      updatedMaterialNameSet(data);
    });
    socket.on("disableRestoreMaterialName", (data) => {
      disableRestoreMaterialNameSet(data);
    });

    // Supplier name real time
    socket.on("createdSupplier", (data) => {
      createdSupplierSet(data);
    });
    socket.on("updatedSupplier", (data) => {
      updatedSupplierSet(data);
    });
    socket.on("disableRestoreSupplier", (data) => {
      disableRestoreSupplierSet(data);
    });

    // Month name real time
    socket.on("createdMonth", (data) => {
      createdMonthSet(data);
    });
    socket.on("updatedMonth", (data) => {
      updatedMonthSet(data);
    });
    socket.on("disableRestoreMonth", (data) => {
      disableRestoreMonthSet(data);
    });
    // Department name real time
    socket.on("createdDepartment", (data) => {
      createdDepartmentSet(data);
    });
    socket.on("updatedDepartment", (data) => {
      updatedDepartmentSet(data);
    });
    socket.on("disableRestoreDepartment", (data) => {
      disableRestoreDepartmentSet(data);
    });
    // Designation  real time
    socket.on("createdDesignation", (data) => {
      createdDesignationSet(data);
    });
    socket.on("updatedDesignation", (data) => {
      updatedDesignationSet(data);
    });
    socket.on("disableRestoreDesignation", (data) => {
      disableRestoreDesignationSet(data);
    });
    // customer name real time
    socket.on("createdCustomer", (data) => {
      createdCustomerSet(data);
    });
    socket.on("updatedCustomer", (data) => {
      updatedCustomerSet(data);
    });
    socket.on("disableRestoreCustomer", (data) => {
      disableRestoreCustomerSet(data);
    });
    // Cash transaction real time
    socket.on("createdCashTran", (data) => {
      createdCashTranSet(data);
    });
    socket.on("updatedCashTran", (data) => {
      updatedCashTranSet(data);
    });
    socket.on("cashTranDisableRestoreSet", (data) => {
      cashTranDisableRestoreSet(data);
    });
    // Bank transaction real time
    socket.on("createdBankTran", (data) => {
      createdBankTranSet(data);
    });
    socket.on("updatedBankTran", (data) => {
      updatedBankTranSet(data);
    });
    socket.on("bankTranDisableRestoreSet", (data) => {
      bankTranDisableRestoreSet(data);
    });
    socket.on("bankTranCode", (data) => {
      bankTranCodeSet(data);
    });
    // Product real time
    socket.on("createdProduct", (data) => {
      createdProductSet(data);
    });
    socket.on("updatedProduct", (data) => {
      updatedProductSet(data);
    });
    socket.on("customerCode", (data) => {
      customerCodeSet(data);
    });
    socket.on("productCode", (data) => {
      productCodeSet(data);
    });
    socket.on("disableRestoreProduct", (data) => {
      disableRestoreProductSet(data);
    });

    //  Material

    socket.on("createdMaterial", (data) => {
      createdMaterialSet(data);
    });
    socket.on("updatedMaterial", (data) => {
      updatedMaterialSet(data);
    });
    socket.on("materialCode", (data) => {
      materialCodeSet(data);
    });

    socket.on("disableRestoreMaterial", (data) => {
      disableRestoreMaterialSet(data);
    });

    //

    socket.on("createdCustomerPay", (data) => {
      createdCustomerPaySet(data);
    });
    socket.on("updatedCustomerPay", (data) => {
      updatedCustomerPaySet(data);
    });

    socket.on("disableRestoreCustomerPay", (data) => {
      customerPayDisableRestoreSet(data);
    });

    getBranches();
  }, []);

  let actionToSwitch = async () => {
    if (selectedBranch == null) {
      swal({
        title: "Select a Switching Branch",
        icon: "warning",
      });
    } else if (user_password.trim() == "") {
      swal({
        title: "Your current account password is Required.",
        icon: "warning",
      });
    } else {
      ajaxReqStatusSet(true);
      let new_branch_id = selectedBranch.branch_id;
      let new_branch_name = selectedBranch.branch_name;
      await axios
        .post(
          `${API_URL}/api/switch-branch`,
          { user_password, new_branch_id, new_branch_name },
          { headers: { "auth-token": authInfo.token } }
        )
        .then((res) => {
          ajaxReqStatusSet(false);
          //  return false
          if (res.data.error == false) {
            sessionStorage.setItem("auth_info", JSON.stringify(res.data));

            window.location.reload();
          } else {
            swal({
              title: `${res.data.message}`,
              icon: "warning",
            });
          }
        });
    }
  };

  let getBranches = async () => {
    await axios
      .post(`${API_URL}/api/get-branches`, null, {
        headers: { "auth-token": authInfo.token },
      })
      .then((res) => {
        let data = res.data.message;
        //  data.unshift({branch_name:'All Branch',branch_id:0})
        branchesSet(data);
      });
  };

  // hover effect state 
  const [dashboardHover, setDashboardHover] = useState(false);
  const [salesHover, setSalesHover] = useState(false);
  const [posHover, setPosHover] = useState(false);
  const [searchHover, setSearchHover] = useState(false);
  const [serviceHover, setServiceHover] = useState(false);
  const [purchaseHover, setPurchaseHover] = useState(false);
  const [manufacturingHover, setManufacturingHover] = useState(false);
  const [inventoryHover, setInventoryHover] = useState(false);
  const [accountsHover, setAccountsHover] = useState(false);
  const [hrHover, setHrHover] = useState(false);
  const [reportHover, setReportHover] = useState(false);
  const [administrationHover, setAdminstrationHover] = useState(false);
  const [settingsHover, setSettingsHover] = useState(false);
  const [quotationHover, setQuotationHover] = useState(false);
  const [crmHover, setCrmHover] = useState(false);











  return (
    <div className="app-gap">
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, {
              [classes.hide]: open,
            })}
          >
            <MenuIcon />
          </IconButton>
          <BottomNavigation
            value={value}
            className={`${classes.root} ${classes.Mui}`}
            onChange={(event, newValue) => {
              setValue(newValue);
            }}
            showLabels
          >
            <BottomNavigationAction
              component={Link}
              to="/"
              label="Dashboard"
              onMouseEnter={() => setDashboardHover(true)}
              onMouseLeave={() => setDashboardHover(false)}
              style={{
                color: dashboardHover ? "white" : "#0F7E77",
                fontSize: "2rem",
                backgroundColor: dashboardHover ? "#286E78" : "transparent",
                borderRadius: 2,
                transition: "all 0.3s ease",
              }}
              icon={
                <img
                  src={dashboardHover ? DashboardIcon2 : DashboardIcon}
                  alt="Dashboard"
                  style={{ width: 20, height: 20 }}
                />
              }
            />
            <BottomNavigationAction
              {...(path == "stock" ? "" : "")}
              component={Link}
              to="/stock/product-search"
              label="Product Search"
              onMouseEnter={() => setSearchHover(true)}
              onMouseLeave={() => setSearchHover(false)}
              style={{
                minWidth: "fit-content",
                width: "fit-content",
                color: searchHover ? "white" : "#0F7E77",
                fontSize: "2rem",
                backgroundColor: searchHover ? "#286E78" : "transparent",
                borderRadius: 2,
                transition: "all 0.3s ease",
              }}
              icon={
                <img
                  src={searchHover ? search2 : search}
                  alt="Dashboard"
                  style={{ width: 20, height: 20 }}
                />
              }
            />
            <BottomNavigationAction
              {...(path == "sales" ? "" : "")}
              component={Link}
              to="/sales"
              label="Sales"
              onMouseEnter={() => setSalesHover(true)}
              onMouseLeave={() => setSalesHover(false)}
              style={{
                color: salesHover ? "white" : "#0F7E77",
                fontSize: "2rem",
                backgroundColor: salesHover ? "#286E78" : "transparent",
                borderRadius: 2,
                transition: "all 0.3s ease",
              }}
              icon={
                <img
                  src={salesHover ? Sales2 : Sales}
                  alt="Dashboard"
                  style={{ width: 20, height: 20 }}
                />
              }
            />

            {/* <BottomNavigationAction
              {...(path == "sales" ? "" : "")}
              component={Link}
              to="/sales/pos-entry"
              label="POS"
              onMouseEnter={() => setPosHover(true)}
              onMouseLeave={() => setPosHover(false)}
              style={{
                color: posHover? "white": "#0F7E77",
                fontSize: "2rem",
                backgroundColor: posHover ? "#286E78" : "transparent", 
                borderRadius: 2, 
                transition: "all 0.3s ease",
              }}
              icon={
                <img
                  src={posHover ? Pos2: Pos}
                  alt="Dashboard"
                  style={{ width: 25, height: 25 }}
                />
              }
            /> */}
            <BottomNavigationAction
              {...(path == "sales" ? "" : "")}
              component={Link}
              to="/quotation"
              label="Quotation"
              onMouseEnter={() => setQuotationHover(true)}
              onMouseLeave={() => setQuotationHover(false)}
              style={{
                color: quotationHover ? "white" : "#0F7E77",
                fontSize: "2rem",
                backgroundColor: quotationHover ? "#286E78" : "transparent",
                borderRadius: 2,
                transition: "all 0.3s ease",
              }}
              icon={
                <img
                  src={quotationHover ? QuotationIcon2 : QuotationIcon}
                  alt="Quotation"
                  style={{ width: 20, height: 20 }}
                />
              }
            />
            {/* <BottomNavigationAction
              component={Link}
              to="/service"
              label="Service"
              onMouseEnter={() => setServiceHover(true)}
              onMouseLeave={() => setServiceHover(false)}
              style={{
                color: serviceHover? "white": "#0F7E77",
                fontSize: "2rem",
                backgroundColor: serviceHover ? "#286E78" : "transparent", 
                borderRadius: 2, 
                transition: "all 0.3s ease",
              }}
              icon={
                <img
                  src={serviceHover ? Service2: Service}
                  alt="Dashboard"
                  style={{ width: 20, height: 20 }}
                />
              }
            /> */}
            <BottomNavigationAction
              component={Link}
              to="/purchase"
              label="Purchase"
              onMouseEnter={() => setPurchaseHover(true)}
              onMouseLeave={() => setPurchaseHover(false)}
              style={{
                color: purchaseHover ? "white" : "#0F7E77",
                fontSize: "2rem",
                backgroundColor: purchaseHover ? "#286E78" : "transparent",
                borderRadius: 2,
                transition: "all 0.3s ease",
              }}
              icon={
                <img
                  src={purchaseHover ? Purchase2 : Purchase}
                  alt="Dashboard"
                  style={{ width: 20, height: 20 }}
                />
              }
            />
            {/* <BottomNavigationAction
              component={Link}
              to="/production"
              label="Manufacturing"
              onMouseEnter={() => setManufacturingHover(true)}
              onMouseLeave={() => setManufacturingHover(false)}
              style={{
                color: manufacturingHover? "white": "#0F7E77",
                fontSize: "2rem",
                backgroundColor: manufacturingHover ? "#286E78" : "transparent", 
                borderRadius: 2, 
                transition: "all 0.3s ease",
              }}
              icon={
                <img
                  src={manufacturingHover ? Manufacturing2: Manufacturing}
                  alt="Dashboard"
                  style={{ width: 20, height: 20 }}
                />
              }
            /> */}
            <BottomNavigationAction
              component={Link}
              to="/stock"
              label="Inventory"
              onMouseEnter={() => setInventoryHover(true)}
              onMouseLeave={() => setInventoryHover(false)}
              style={{
                color: inventoryHover ? "white" : "#0F7E77",
                fontSize: "2rem",
                backgroundColor: inventoryHover ? "#286E78" : "transparent",
                borderRadius: 2,
                transition: "all 0.3s ease",
              }}
              icon={
                <img
                  src={inventoryHover ? Inventory2 : Inventory}
                  alt="Dashboard"
                  style={{ width: 20, height: 20 }}
                />
              }
            />
            <BottomNavigationAction
              component={Link}
              to="/accounts"
              label="Accounts"
              onMouseEnter={() => setAccountsHover(true)}
              onMouseLeave={() => setAccountsHover(false)}
              style={{
                color: accountsHover ? "white" : "#0F7E77",
                fontSize: "2rem",
                backgroundColor: accountsHover ? "#286E78" : "transparent",
                borderRadius: 2,
                transition: "all 0.3s ease",
              }}
              icon={
                <img
                  src={accountsHover ? Accounts2 : Accounts}
                  alt="Dashboard"
                  style={{ width: 20, height: 20 }}
                />
              }
            />
            <BottomNavigationAction
              component={Link}
              to="/hrpayroll"
              label="HR&Payroll"
              onMouseEnter={() => setHrHover(true)}
              onMouseLeave={() => setHrHover(false)}
              style={{
                color: hrHover ? "white" : "#0F7E77",
                fontSize: "2rem",
                backgroundColor: hrHover ? "#286E78" : "transparent",
                borderRadius: 2,
                transition: "all 0.3s ease",
              }}
              icon={
                <img
                  src={hrHover ? Hr2 : Hr}
                  alt="Dashboard"
                  style={{ width: 20, height: 20 }}
                />
              }
            />
            <BottomNavigationAction
              component={Link}
              to="/reports"
              label="Reports"
              onMouseEnter={() => setReportHover(true)}
              onMouseLeave={() => setReportHover(false)}
              style={{
                color: reportHover ? "white" : "#0F7E77",
                fontSize: "2rem",
                backgroundColor: reportHover ? "#286E78" : "transparent",
                borderRadius: 2,
                transition: "all 0.3s ease",
              }}
              icon={
                <img
                  src={reportHover ? Report2 : Report}
                  alt="Dashboard"
                  style={{ width: 20, height: 20 }}
                />
              }
            />

            <BottomNavigationAction
              component={Link}
              to="/administration"
              label="Administration"
              onMouseEnter={() => setAdminstrationHover(true)}
              onMouseLeave={() => setAdminstrationHover(false)}
              style={{
                color: administrationHover ? "white" : "#0F7E77",
                fontSize: "2rem",
                backgroundColor: administrationHover ? "#286E78" : "transparent",
                borderRadius: 2,
                transition: "all 0.3s ease",
              }}
              icon={
                <img
                  src={administrationHover ? CRM2 : CRM}
                  alt="Administration"
                  style={{ width: 20, height: 20 }}
                />
              }
            />

            <BottomNavigationAction
              component={Link}
              to="/crm/dashboard"
              label="CRM"
              onMouseEnter={() => setCrmHover(true)}
              onMouseLeave={() => setCrmHover(false)}
              style={{
                color: crmHover ? "white" : "#0F7E77",
                fontSize: "2rem",
                backgroundColor: crmHover ? "#286E78" : "transparent",
                borderRadius: 2,
                transition: "all 0.3s ease",
              }}
              icon={
                <img
                  src={crmHover ? CRM2 : CRM}
                  alt="CRM"
                  style={{ width: 20, height: 20 }}
                />
              }
            />

            {authInfo.role == "super_admin" ? (
              <BottomNavigationAction
                component={Link}
                to="#"
                onClick={() => branchSwitchSet(true)}
                label="Switch"
                onMouseEnter={() => setSettingsHover(true)}
                onMouseLeave={() => setSettingsHover(false)}
                style={{
                  color: settingsHover ? "white" : "#0F7E77",
                  fontSize: "2rem",
                  backgroundColor: settingsHover ? "#286E78" : "transparent",
                  borderRadius: 2,
                  transition: "all 0.3s ease",
                }}
                icon={
                  <img
                    src={settingsHover ? Settings2 : Settings}
                    alt="Administration"
                    style={{ width: 20, height: 20 }}
                  />
                }
              />
            ) : (
              ""
            )}
          </BottomNavigation>
          {/*  */}

          <IconButton
            style={{ display: "none" }}
            aria-label="show 17 new notifications"
            color="inherit"
          >
            <Badge badgeContent={17} color="secondary" overlap="rectangular">
              <NotificationsIcon />
            </Badge>
          </IconButton>
          <div
            className={(classes.root, classes.usersettingaction)}
            aria-controls="fade-menu"
            aria-haspopup="true"
            onClick={handleClick}
          >
            <Avatar>{authInfo.userInfo.user_full_name.substring(0, 1)} </Avatar>
          </div>
          <Menu
            id="fade-menu"
            anchorEl={anchorEl}
            keepMounted
            open={openusersetting}
            onClose={handleClose}
            TransitionComponent={Fade}
          >
            {/* <MenuItem onClick={handleClose}>Profile</MenuItem>
        <MenuItem onClick={handleClose}>My account</MenuItem> */}
            <MenuItem onClick={logout}>Logout</MenuItem>
          </Menu>

          {/*  */}
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          {/* <b className={classes.companyTitle}> {authInfo.institution}</b> */}
          <span style={{ display: "block", fontFamily: "Times New Roman", fontWeight: "700", textAlign: "center" }}>
            <p style={{ margin: "0", fontStyle: "italic" }}>Account Resolver</p>
            <b style={{ marginTop: "2px", fontStyle: "italic", color: "#E36D56" }}>(DeshIT-BD)</b>
          </span>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </div>
        <List>
          {currentRoute == "stock" ? (
            <>
              <Link to="/stock" className={classes.linkStyle}>
                <ListItem button key="HomeIcon">
                  <ListItemText
                    className="module-text"
                    primary={"Inventory  Module"}
                  />
                </ListItem>
              </Link>
            </>
          ) : (
            ""
          )}

          {currentRoute == "sales" ? (
            <>
              <Link to="/sales" className={classes.linkStyle}>
                <ListItem button key="HomeIcon">
                  <ListItemText
                    className="module-text"
                    primary={"Sales Module"}
                  />
                </ListItem>
              </Link>
            </>
          ) : (
            ""
          )}

          {currentRoute == "service" ? (
            <>
              <Link to="/service" className={classes.linkStyle}>
                <ListItem button key="HomeIcon">
                  <ListItemText
                    className="module-text"
                    primary={"Service Module"}
                  />
                </ListItem>
              </Link>
            </>
          ) : (
            ""
          )}

          {currentRoute == "purchase" ? (
            <>
              <Link to="/purchase" className={classes.linkStyle}>
                <ListItem button key="HomeIcon">
                  <ListItemText
                    className="module-text"
                    primary={"Purchase Module"}
                  />
                </ListItem>
              </Link>
            </>
          ) : (
            ""
          )}

          {currentRoute == "production" ? (
            <>
              <Link to="/production" className={classes.linkStyle}>
                <ListItem button key="HomeIcon">
                  <ListItemText
                    className="module-text"
                    primary={"Manufacturing Module"}
                  />
                </ListItem>
              </Link>
            </>
          ) : (
            ""
          )}

          {currentRoute == "accounts" ? (
            <>
              <Link
                to="/accounts"
                className={classes.linkStyle}
                style={{ fontSize: "14px" }}
              >
                <ListItem button key="HomeIcon" style={{ fontSize: "14px" }}>
                  <ListItemText
                    className="module-text"
                    primary={"Financial Accounts"}
                  />
                </ListItem>
              </Link>
            </>
          ) : (
            ""
          )}

          {currentRoute == "service" ? (
            <>
              {accessChecker("service_entry") > -1 ? (
                <Link to="/service/service-entry" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Services Entry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("service_expense_entry") > -1 ? (
                <Link
                  to="/service/service-purchase-entry"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Services Expense Entry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("service_record") > -1 ? (
                <Link
                  to="/service/service-record"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Services Record"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("service_expense_record") > -1 ? (
                <Link
                  to="/service/service-expense-record"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Services Expense Record"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("service_invoice") > -1 ? (
                <Link
                  to="/service/service-invoice"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Services Invoice"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("service_expense_invoice") > -1 ? (
                <Link
                  to="/service/service-item-invoice"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Services Expense Invoice"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}
              {accessChecker("service_report") > -1 ? (
                <Link
                  to="/service/services-report"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Services Report"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}
          {currentRoute == "crm" ? (
            <div className={classes.crmSidebarPanel}>
              {accessChecker("service_entry") > -1 ? (
                <Link to="/crm/dashboard" className={classes.crmSidebarLink}>
                  <ListItem
                    button
                    key="StyleIcon"
                    className={clsx(classes.crmSidebarItem, {
                      [classes.crmSidebarItemActive]: crmDashboardActive,
                    })}
                  >
                    <ListItemText
                      className={classes.crmSidebarItemText}
                      primary={"Dashboard"}
                    />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {/* {accessChecker("service_expense_entry") > -1 ? (
                <Link
                  to="/crm/customers"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Customers"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("service_record") > -1 ? (
                <Link
                  to="/crm/sales_visits"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Sales Visits"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("service_expense_record") > -1 ? (
                <Link
                  to="/crm/follow_ups"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Follow-ups"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("service_invoice") > -1 ? (
                <Link
                  to="/crm/orders_po"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Orders / PO"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("service_expense_invoice") > -1 ? (
                <Link
                  to="/crm/payments"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Payments"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )} */}
              {accessChecker("service_report") > -1 ? (
                <Link
                  to="/crm/salespeople"
                  className={classes.crmSidebarLink}
                >
                  <ListItem
                    button
                    key="crm-salespeople"
                    className={clsx(classes.crmSidebarItem, {
                      [classes.crmSidebarItemActive]: crmSalespeopleActive,
                    })}
                  >
                    <ListItemText
                      className={classes.crmSidebarItemText}
                      primary={"Salespeople"}
                    />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}
              {accessChecker("service_report") > -1 ? (
                <Link
                  to="/crm/customers"
                  className={classes.crmSidebarLink}
                >
                  <ListItem
                    button
                    key="crm-customers"
                    className={clsx(classes.crmSidebarItem, {
                      [classes.crmSidebarItemActive]: crmCustomersActive,
                    })}
                  >
                    <ListItemText
                      className={classes.crmSidebarItemText}
                      primary={"Customers"}
                    />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}
              {accessChecker("service_report") > -1 ? (
                <Link
                  to="/crm/follow_ups"
                  className={classes.crmSidebarLink}
                >
                  <ListItem
                    button
                    key="crm-followups"
                    className={clsx(classes.crmSidebarItem, {
                      [classes.crmSidebarItemActive]: crmFollowupsActive,
                    })}
                  >
                    <ListItemText
                      className={classes.crmSidebarItemText}
                      primary={"Follow-Ups"}
                    />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}
              {accessChecker("service_report") > -1 ? (
                <Link
                  to="/crm/crm-reports"
                  className={classes.crmSidebarLink}
                >
                  <ListItem
                    button
                    key="StyleIcon"
                    className={clsx(classes.crmSidebarItem, {
                      [classes.crmSidebarItemActive]: crmReportsActive,
                    })}
                  >
                    <ListItemText
                      className={classes.crmSidebarItemText}
                      primary={"CRM Reports"}
                    />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}
              {/* {accessChecker("service_report") > -1 ? (
                <Link
                  to="/crm/settings"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Settings"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )} */}
            </div>
          ) : (
            ""
          )}

          {currentRoute == "reports" ? (
            <>
              <Link to="/reports" className={classes.linkStyle}>
                <ListItem button key="HomeIcon">
                  <ListItemText
                    className="module-text"
                    primary={"Reports Module"}
                  />
                </ListItem>
              </Link>

              {accessChecker("r_profit_loss") > -1 ? (
                <Link
                  to="/reports/cash_bank_balance"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Cash & Bank Balance"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("r_profit_loss") > -1 ? (
                <Link to="/reports/profit-loss" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Profit & Loss"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("r_product_stock") > -1 ? (
                <Link
                  to="/reports/product-stock-report"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Product Stock"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {/* {accessChecker("r_material_stock") > -1 ? (
                <Link
                  to="/reports/material-stock"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Material Stock "} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )} */}
              {accessChecker("daily_ledger") > -1 ? (
                <Link to="/reports/daily-ledger" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Daily Ledger"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("cash_ledger") > -1 ? (
                <Link to="/reports/cash-ledger" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Cash Ledger"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("bank_account_ledger") > -1 ? (
                <Link to="/reports/bank-ledger" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Bank Account   Ledger"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("r_customer_ledger") > -1 ? (
                <Link
                  to="/reports/customer-ledger"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Customer   Ledger"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("r_supplier_ledger") > -1 ? (
                <Link
                  to="/reports/supplier-ledger"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Supplier  Ledger"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {/* {accessChecker("r_material_ledger") > -1 ? (
                <Link
                  to="/reports/material-ledger"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Material Ledger "} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )} */}

              {accessChecker("r_product_ledger") > -1 ? (
                <Link
                  to="/reports/product-ledger"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Product Ledger"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("r_supplier_due_list") > -1 ? (
                <Link
                  to="/reports/supplier-due-list"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Supplier Due Report"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("r_customer_due_list") > -1 ? (
                <Link
                  to="/reports/customer-due-list"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Customer  Due Report"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("r_cash_statement") > -1 ? (
                <Link
                  to="/reports/cash_statement"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Cash Statement"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("r_sales_invoice") > -1 ? (
                <Link to="/reports/sales-invoice" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Sales Invoice"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("customer_transaction_invoice") > -1 ? (
                <Link
                  to="/reports/customer-transactions"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Customer Tran. Invoice"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("r_quotation_invoice") > -1 ? (
                <Link
                  to="/reports/quotation-invoice"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Quotation Invoice"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("r_purchase_invoice") > -1 ? (
                <Link
                  to="/reports/purchase-invoice"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Product Purchase Invoice"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("r_production_invoice") > -1 ? (
                <Link
                  to="/reports/production-invoice"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Production  Invoice"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {/* {accessChecker("r_material_purchase_invoice") > -1 ? (
                <Link
                  to="/reports/material-purchase-invoice"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Material Purchase Invoice"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )} */}

              {accessChecker("r_customer_transaction") > -1 ? (
                <Link
                  to="/reports/customer-transation-history"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Customer   Transactions"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("r_supplier_transaction") > -1 ? (
                <Link
                  to="/reports/supplier-transaction-history"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Supplier  Transactions"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("r_cash_transaction") > -1 ? (
                <Link
                  to="/reports/cash-transaction-report"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Others Transaction Report"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("r_bank_transaction") > -1 ? (
                <Link
                  to="/reports/bank-transaction-report"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Bank Transaction Report"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("r_salary_payment") > -1 ? (
                <Link
                  to="/reports/salary-payment-report"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Salary Payment Report"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("r_sales_record") > -1 ? (
                <Link to="/reports/sales-record" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Sales Record"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("r_quotation_record") > -1 ? (
                <Link
                  to="/reports/quotation-record"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Quotation Record"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("r_purchase_record") > -1 ? (
                <Link
                  to="/reports/purchase-record"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Product Purchase Record"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {/* {accessChecker("r_production_record") > -1 ? (
                <Link
                  to="/reports/production-record"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Production Record "} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )} */}

              {/* {accessChecker("r_material_pur_record") > -1 ? (
                <Link
                  to="/reports/material-purchase-record"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Material Purchase Record "} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )} */}

              {accessChecker("r_prod_transfer_record") > -1 ? (
                <Link
                  to="/reports/transfer-record"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Product Transfer Record"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("r_prod_receive_record") > -1 ? (
                <Link
                  to="/reports/receive-record"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Product Receive Record"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("r_sales_return_list") > -1 ? (
                <Link
                  to="/reports/sales-return-list"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Sales Return List"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("r_purchase_return_list") > -1 ? (
                <Link
                  to="/reports/purchase-return-list"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Product Purchase Return List"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("r_customer_list") > -1 ? (
                <Link to="/reports/customer-list" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Customer   List"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("r_supplier_list") > -1 ? (
                <Link to="/reports/supplier-list" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Supplier  List"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {/* {accessChecker("r_material_damage_list") > -1 ? (
                <Link
                  to="/reports/material-damage-list"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Material Damage List "} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )} */}

              {/* {accessChecker("r_material_list") > -1 ? (
                <Link to="/reports/material-list" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Material  List "} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )} */}

              {accessChecker("r_product_damage_list") > -1 ? (
                <Link
                  to="/reports/product-damage-list"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Product Damage Record"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("r_product_list") > -1 ? (
                <Link to="/reports/product-list" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Product List"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("product_re_order_list") > -1 ? (
                <Link
                  to="/reports/product-re-order-list"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Product Re-Order List"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {/* {accessChecker("material_re_order_list") > -1 ? (
                <Link
                  to="/reports/material-re-order-list"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Material Re-Order List"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )} */}
            </>
          ) : (
            ""
          )}

          {currentRoute == "hrpayroll" ? (
            <>
              <Link to="/hrpayroll" className={classes.linkStyle}>
                <ListItem button key="HomeIcon">
                  <ListItemText
                    className="module-text"
                    primary={"HR&Payroll Module"}
                  />
                </ListItem>
              </Link>
            </>
          ) : (
            ""
          )}

          {currentRoute == "administration" ? (
            <>
              <Link to="/administration" className={classes.linkStyle}>
                <ListItem button key="HomeIcon">
                  <ListItemText
                    className="module-text"
                    primary={"Administration"}
                  />
                </ListItem>
              </Link>
            </>
          ) : (
            ""
          )}

          {currentRoute == "" || currentRoute == "dashboard" ? (
            <Fragment>
              <Link to="/sales" className={classes.linkStyle}>
                <ListItem button key="StyleIcon">
                  <ListItemIcon>
                    <img
                      src={Sales}
                      alt="Sales"
                      style={{ width: 20, height: 20 }}
                    />
                  </ListItemIcon>
                  <ListItemText primary={"Sales Module"} />
                </ListItem>
              </Link>

              {/* <Link to="/sales" className={classes.linkStyle}>
                <ListItem button key="StyleIcon">
                  <ListItemIcon>
                    <img
                        src= {Pos}
                        alt="Quotation"
                        style={{ width: 25, height: 25 }}
                      /> 
                  </ListItemIcon>
                  <ListItemText primary={"POS Module"} />
                </ListItem>
              </Link> */}

              <Link to="/quotation" className={classes.linkStyle}>
                <ListItem button key="StyleIcon">
                  <ListItemIcon>
                    <img
                      src={QuotationIcon}
                      alt="Quotation"
                      style={{ width: 20, height: 20 }}
                    />
                  </ListItemIcon>
                  <ListItemText primary={"Quotation Module"} />
                </ListItem>
              </Link>


              <Link to="/purchase" className={classes.linkStyle}>
                <ListItem button key="StyleIcon">
                  <ListItemIcon>
                    <img
                      src={Purchase}
                      alt="Purchase"
                      style={{ width: 20, height: 20 }}
                    />
                  </ListItemIcon>
                  <ListItemText primary={"Purchase Module"} />
                </ListItem>
              </Link>

              {/* <Link to="/production" className={classes.linkStyle}>
                <ListItem button key="StyleIcon">
                  <ListItemIcon>
                    <img
                        src= {Manufacturing}
                        alt="Manufacturing"
                        style={{ width: 20, height: 20 }}
                      /> 
                  </ListItemIcon>
                  <ListItemText primary={"Manufacturing Module"} />
                </ListItem>
              </Link> */}

              <Link to="/stock" className={classes.linkStyle}>
                <ListItem button key="StyleIcon">
                  <ListItemIcon>
                    <img
                      src={Inventory}
                      alt="Inventory"
                      style={{ width: 20, height: 20 }}
                    />
                  </ListItemIcon>
                  <ListItemText primary={"Inventory Module"} />
                </ListItem>
              </Link>

              <Link to="/accounts" className={classes.linkStyle}>
                <ListItem button key="StyleIcon">
                  <ListItemIcon>
                    <img
                      src={Accounts}
                      alt="Accounts"
                      style={{ width: 20, height: 20 }}
                    />
                  </ListItemIcon>
                  <ListItemText primary={"Financial Accounts"} />
                </ListItem>
              </Link>
              <Link to="/hrpayroll" className={classes.linkStyle}>
                <ListItem button key="StyleIcon">
                  <ListItemIcon>
                    <img
                      src={Hr}
                      alt="HR&Payroll"
                      style={{ width: 20, height: 20 }}
                    />
                  </ListItemIcon>
                  <ListItemText primary={"HR & Payroll"} />
                </ListItem>
              </Link>
              <Link to="/reports" className={classes.linkStyle}>
                <ListItem button key="StyleIcon">
                  <ListItemIcon>
                    <img
                      src={Report}
                      alt="Report"
                      style={{ width: 20, height: 20 }}
                    />
                  </ListItemIcon>
                  <ListItemText primary={"Reports Module"} />
                </ListItem>
              </Link>

              <Link to="/administration" className={classes.linkStyle}>
                <ListItem button key="StyleIcon">
                  <ListItemIcon>
                    <img
                      src={CRM}
                      alt="CRM"
                      style={{ width: 20, height: 20 }}
                    />
                  </ListItemIcon>
                  <ListItemText primary={"Administration"} />
                </ListItem>
              </Link>
            </Fragment>
          ) : (
            ""
          )}
          {currentRoute == "stock" ? (
            <>
              {accessChecker("product_transfer") > -1 ? (
                <Link
                  to="/stock/product-transfer"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Product Transfer Entry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}
              {accessChecker("product_transfer") > -1 ? (
                <Link
                  to="/stock/opening-stock-entry"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Opening Stock Entry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}
              {accessChecker("product_search") > -1 ? (
                <Link
                  to="/stock/product-search"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Product Search"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("product_damage") > -1 ? (
                <Link to="/stock/product-damage" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Product Damage Entry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {/* {accessChecker("material_damage") > -1 ? (
                <Link to="/stock/material-damage" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Material Damage Entry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )} */}

              {accessChecker("product_stock") > -1 ? (
                <Link
                  to="/stock/product-stock-report"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Product  Stock"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {/* {accessChecker("material_stock_m") > -1 ? (
                <Link to="/stock/material-stock" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Material Stock"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )} */}

              {
                <Link
                  to="/stock/product-rackwise-stock"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"RackWise Stock"} />
                  </ListItem>
                </Link>
              }

              {accessChecker("product_ledger") > -1 ? (
                <Link to="/stock/product-ledger" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Product Ledger "} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}
              {/* {accessChecker("material_ledger") > -1 ? (
                <Link to="/stock/material-ledger" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Material Ledger "} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )} */}
              {accessChecker("product_transfer_list") > -1 ? (
                <Link to="/stock/transfer-record" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Product Transfer List"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}
              {accessChecker("product_floor_transfer") > -1 ? (
                <Link
                  to="/stock/floor-transfer-record"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Floor Transfer List"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("product_receive_list") > -1 ? (
                <Link to="/stock/receive-record" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Product Receive List"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("product_damage_list") > -1 ? (
                <Link
                  to="/stock/product-damage-list"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Product Damage List"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {/* {accessChecker("material_damage_list") > -1 ? (
                <Link
                  to="/stock/material-damage-list"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Material Damage List"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )} */}

              {accessChecker("product_price_list") > -1 ? (
                <Link to="/stock/product-list" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Product Price List"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("product_re_order_list") > -1 ? (
                <Link
                  to="/stock/product-re-order-list"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Product Re-Order  List "} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {/* {accessChecker("material_re_order_list") > -1 ? (
                <Link
                  to="/stock/material-re-order-list"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Material Re-Order  List "} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )} */}
              {
                <Link to="/stock/slow-products" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Slow Products"} />
                  </ListItem>
                </Link>
              }
              {
                <Link to="/stock/old-stock" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Old Stock"} />
                  </ListItem>
                </Link>
              }
            </>
          ) : (
            ""
          )}
          {/* Sales's Menus */}
          {currentRoute == "sales" ? (
            <Fragment>
              {accessChecker("sales_entry") > -1 ? (
                <Link to="/sales/sales-entry" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Sales Entry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("customer_entry") > -1 ? (
                <Link
                  to="/sales/customers-manage"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Customer Entry "} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}
              {
                <Link
                  to="/sales/contact-persons-manage"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Contact Person Entry"} />
                  </ListItem>
                </Link>
              }
              {
                <Link
                  to="/sales/contact-persons-performance"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Contact Person Performance"} />
                  </ListItem>
                </Link>
              }

              {accessChecker("sales_return") > -1 ? (
                <Link to="/sales/sales-return" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Sales Return Entry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}



              {accessChecker("sales_record") > -1 ? (
                <Link to="/sales/sales-record" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Sales Record"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("sales_invoice") > -1 ? (
                <Link to="/sales/sales-invoice" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Sales Invoice"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {
                <Link
                  to="/sales/sales-po-invoice"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Sales PO Invoices"} />
                  </ListItem>
                </Link>
              }



              {accessChecker("sales_return_record") > -1 ? (
                <Link
                  to="/sales/sales-return-list"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Sales Return Record"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}
              {accessChecker("customer_due_list") > -1 ? (
                <Link
                  to="/sales/customer-due-list"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Customer Due Report"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("customer_list") > -1 ? (
                <Link to="/sales/customer-list" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Customer List"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("customer_ledger") > -1 ? (
                <Link to="/sales/customer-ledger" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Customer Ledger"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("customer_transaction") > -1 ? (
                <Link
                  to="/sales/customer-transation-history"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon" style={{ fontSize: "10px" }}>
                    <ListItemText primary={"Customer Transaction History"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}
            </Fragment>
          ) : (
            ""
          )}

          {/* Quotation  */}
          {currentRoute == "quotation" ? (
            <Fragment>
              {accessChecker("quotation_entry") > -1 ? (
                <Link to="/sales/quotation-entry" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Quotation Entry "} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("quotation_record") > -1 ? (
                <Link
                  to="/sales/quotation-record"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Quotation Record "} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("quotation_invoice") > -1 ? (
                <Link
                  to="/sales/quotation-invoice"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Quotation Invoice "} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}


            </Fragment>
          ) : (
            ""
          )}
          {/* end quotation  */}
          {currentRoute == "accounts" ? (
            <Fragment>
              {accessChecker("customer_transaction_m") > -1 ? (
                <Link
                  to="/accounts/customer-payments-manage"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Customer TransactionEntry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("supplier_payment") > -1 ? (
                <Link
                  to="/accounts/supplier-payments-manage"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Supplier Transaction Entry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("bank_transaction") > -1 ? (
                <Link
                  to="/accounts/bank-transactions-manage"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Bank Transaction Entry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("cash_transaction") > -1 ? (
                <Link
                  to="/accounts/cash-transactions-manage"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Others Transaction Entry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("transaction_accounts") > -1 ? (
                <Link
                  to="/accounts/transaction-accounts-manage"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Others Transaction Acc. Entry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}
              {accessChecker("bank_accounts") > -1 ? (
                <Link
                  to="/accounts/bank-accounts-manage"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Bank Account Entry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("cash_transaction_d_w") > -1 ? (
                <Link
                  to="/accounts/cash-deposit-withdraw"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Cash Transaction Entry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("customer_transaction_invoice") > -1 ? (
                <Link
                  to="/accounts/customer-transactions"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Customer Tran. Invoice"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("bank_transaction_report_m") > -1 ? (
                <Link
                  to="/accounts/bank-transaction-report"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Bank Transaction Report"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("r_customer_transaction") > -1 ? (
                <Link
                  to="/accounts/customer-transation-history"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Customer Transaction Report"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}
              {accessChecker("r_supplier_transaction") > -1 ? (
                <Link
                  to="/accounts/supplier-transation-history"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Supplier Transaction Report"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}
              {accessChecker("cash_transaction_report") > -1 ? (
                <Link
                  to="/accounts/cash-transaction-report"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Others Transaction Report"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("bank_account_ledger") > -1 ? (
                <Link to="/accounts/bank-ledger" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Bank Account Ledger"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("cash_ledger") > -1 ? (
                <Link to="/accounts/cash-ledger" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Cash Ledger"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("daily_ledger") > -1 ? (
                <Link to="/accounts/daily-ledger" className={classes.linkStyle}>
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Daily Ledger"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}
            </Fragment>
          ) : (
            ""
          )}

          {currentRoute == "production" ? (
            <>
              {accessChecker("production_entry") > -1 ? (
                <Link
                  to="/production/production-entry"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Production Entry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("material_purchase") > -1 ? (
                <Link
                  to="/production/material-purchase-entry"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Material Purchase Entry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("supplier_entry") > -1 ? (
                <Link
                  to="/production/suppliers-manage"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Supplier Entry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("material_entry") > -1 ? (
                <Link
                  to="/production/material-entry"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Material Entry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("material_damage_entry") > -1 ? (
                <Link
                  to="/production/material-damage-entry"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Material Damage Entry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("material_names") > -1 ? (
                <Link
                  to="/production/material-name-entry"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Material Names Manage"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("production_invoice") > -1 ? (
                <Link
                  to="/production/production-invoice"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Production Invoice"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("material_purchase_invoice") > -1 ? (
                <Link
                  to="/production/material-purchase-invoice"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Material Purchase Invoice"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}
              {accessChecker("material_stock") > -1 ? (
                <Link
                  to="/production/material-stock"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Material Stock"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}
              {accessChecker("material_ledger") > -1 ? (
                <Link
                  to="/production/material-ledger"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Material Ledger"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("production_record") > -1 ? (
                <Link
                  to="/production/production-record"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Production Record"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("material_purchase_record") > -1 ? (
                <Link
                  to="/production/material-purchase-record"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Material Purchase Record"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("material_damage_list") > -1 ? (
                <Link
                  to="/production/material-damage-list"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Material Damage List"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("material_list") > -1 ? (
                <Link
                  to="/production/material-list"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Material  List"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}

          {currentRoute == "purchase" ? (
            <Fragment>
              {accessChecker("purchase_entry") > -1 ? (
                <Link
                  to="/purchase/purchase-entry"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Purchase Entry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("supplier_entry") > -1 ? (
                <Link
                  to="/purchase/suppliers-manage"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Supplier Entry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {
                <Link
                  to="/purchase/suppliers-contact-person-manage"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Supplier Contact Person"} />
                  </ListItem>
                </Link>
              }

              {
                <Link
                  to="/purchase/suppliers-contact-person-performance"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Supplier Contact Performance"} />
                  </ListItem>
                </Link>
              }

              {accessChecker("purchase_return") > -1 ? (
                <Link
                  to="/purchase/purchase-return"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Purchase Return Entry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("purchase_record") > -1 ? (
                <Link
                  to="/purchase/purchase-record"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Product Purchase Record"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("purchase_invoice") > -1 ? (
                <Link
                  to="/purchase/purchase-invoice"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Product Purchase Invoice"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {
                <Link
                  to="/purchase/purchase-po-invoice"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Purchase PO Invoice"} />
                  </ListItem>
                </Link>
              }

              {accessChecker("purchase_return_list") > -1 ? (
                <Link
                  to="/purchase/purchase-return-list"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Purchase Return List"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("supplier_due_list") > -1 ? (
                <Link
                  to="/purchase/supplier-due-list"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Supplier Due Report"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {
                <Link
                  to="/purchase/supplier-due-monthly"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Supplier Due Monthly"} />
                  </ListItem>
                </Link>
              }

              {accessChecker("supplier_list") > -1 ? (
                <Link
                  to="/purchase/supplier-list"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Supplier  List"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("supplier_ledger") > -1 ? (
                <Link
                  to="/purchase/supplier-ledger"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Supplier Ledger"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}
              {accessChecker("supplier_transaction") > -1 ? (
                <Link
                  to="/purchase/supplier-transaction-history"
                  className={classes.linkStyle}
                >
                  <ListItem button key="StyleIcon">
                    <ListItemText primary={"Supplier Transaction history"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}
            </Fragment>
          ) : (
            ""
          )}
          {currentRoute == "hrpayroll" ? (
            <Fragment>
              {accessChecker("salary") > -1 ? (
                <Link
                  to="/hrpayroll/salary-payment"
                  className={classes.linkStyle}
                >
                  <ListItem button key="PermDataSettingIcon">
                    <ListItemText primary={"Salary Payment Entry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("employee_manage") > -1 ? (
                <Link
                  to="/hrpayroll/employees-manage"
                  className={classes.linkStyle}
                >
                  <ListItem button key="PermDataSettingIcon">
                    <ListItemText primary={"Employee Manage"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("designation_manage") > -1 ? (
                <Link
                  to="/hrpayroll/designations-manage"
                  className={classes.linkStyle}
                >
                  <ListItem button key="PermDataSettingIcon">
                    <ListItemText primary={"Designation Manage"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("department_manage") > -1 ? (
                <Link
                  to="/hrpayroll/departments-manage"
                  className={classes.linkStyle}
                >
                  <ListItem button key="PermDataSettingIcon">
                    <ListItemText primary={"Department Manage"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}
              {accessChecker("month_manage") > -1 ? (
                <Link
                  to="/hrpayroll/months-manage"
                  className={classes.linkStyle}
                >
                  <ListItem button key="PermDataSettingIcon">
                    <ListItemText primary={"Month Manage"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("salary_report") > -1 ? (
                <Link
                  to="/hrpayroll/salary-payment-report"
                  className={classes.linkStyle}
                >
                  <ListItem button key="PermDataSettingIcon">
                    <ListItemText primary={"Salary Payment   Report"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}
            </Fragment>
          ) : (
            ""
          )}
          {/* Administrator's Menus */}
          {currentRoute == "administration" ? (
            <Fragment>
              {accessChecker("product_manage") > -1 ? (
                <Link
                  to="/administration/products-manage"
                  className={classes.linkStyle}
                >
                  <ListItem button key="PermDataSettingIcon">
                    <ListItemText primary={"Product Entry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {/* {accessChecker("material_entry") > -1 ? (
                <Link
                  to="/administration/material-entry"
                  className={classes.linkStyle}
                >
                  <ListItem button key="PermDataSettingIcon">
                    <ListItemText primary={"Material Entry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )} */}

              {accessChecker("product_name_entry") > -1 ? (
                <Link
                  to="/administration/prod-names-manage"
                  className={classes.linkStyle}
                >
                  <ListItem button key="PermDataSettingIcon">
                    <ListItemText primary={"Product Name Entry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("delivery_man_name_entry") > -1 ? (
                <Link
                  to="/administration/delivery-man-name-manage"
                  className={classes.linkStyle}
                >
                  <ListItem button key="PermDataSettingIcon">
                    <ListItemText primary={"Delivery Man Entry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("email_cc_name_entry") > -1 ? (
                <Link
                  to="/administration/email-cc-name"
                  className={classes.linkStyle}
                >
                  <ListItem button key="PermDataSettingIcon">
                    <ListItemText primary={"Email CC Entry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("material_name") > -1 ? (
                <Link
                  to="/administration/material-name-entry"
                  className={classes.linkStyle}
                >
                  <ListItem button key="PermDataSettingIcon">
                    <ListItemText primary={"Material Name Entry"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("area_manage") > -1 ? (
                <Link
                  to="/administration/areas-manage"
                  className={classes.linkStyle}
                >
                  <ListItem button key="PermDataSettingIcon">
                    <ListItemText primary={"Area Manage"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("product_category") > -1 ? (
                <Link
                  to="/administration/prod-category-manage"
                  className={classes.linkStyle}
                >
                  <ListItem button key="PermDataSettingIcon">
                    <ListItemText primary={"Product Categories"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              <Link
                to="/administration/prod-brands-manage"
                className={classes.linkStyle}
              >
                <ListItem button key="PermDataSettingIcon">
                  <ListItemText primary={"Product Brands"} />
                </ListItem>
              </Link>

              <Link
                to="/administration/prod-colors-manage"
                className={classes.linkStyle}
              >
                <ListItem button key="PermDataSettingIcon">
                  <ListItemText primary={"Product Countries"} />
                </ListItem>
              </Link>
              <Link
                to="/administration/prod-floors-manage"
                className={classes.linkStyle}
              >
                <ListItem button key="PermDataSettingIcon">
                  <ListItemText primary={"Product Floors"} />
                </ListItem>
              </Link>

              <Link
                to="/administration/prod-racks-manage"
                className={classes.linkStyle}
              >
                <ListItem button key="PermDataSettingIcon">
                  <ListItemText primary={"Product Racks"} />
                </ListItem>
              </Link>

              {accessChecker("product_unit") > -1 ? (
                <Link
                  to="/administration/prod-units-manage"
                  className={classes.linkStyle}
                >
                  <ListItem button key="PermDataSettingIcon">
                    <ListItemText primary={"Product Units"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {accessChecker("user_manage") > -1 ||
                authInfo.role == "super_admin" ? (
                <Link
                  to="/administration/users-manage"
                  className={classes.linkStyle}
                >
                  <ListItem button key="PermDataSettingIcon">
                    <ListItemText primary={"Users Manage"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {/* <Link to="/administration/warehouses-manage" className={classes.linkStyle}>
            <ListItem button key="PermDataSettingIcon">
              <ListItemIcon><StyleIcon className={classes.drawerIconColor}/></ListItemIcon>
              <ListItemText primary={"Warehouse Manage"} />
            </ListItem> 
            </Link> */}

              {accessChecker("branch_manage") > -1 ? (
                <Link
                  to="/administration/branches-manage"
                  className={classes.linkStyle}
                >
                  <ListItem button key="PermDataSettingIcon">
                    <ListItemText primary={"Branch Manage"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}


              {accessChecker("company_profile") > -1 ? (
                <Link
                  to="/administration/institution-profile"
                  className={classes.linkStyle}
                >
                  <ListItem button key="PermDataSettingIcon">
                    <ListItemText primary={"Company Profile"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

              {/* order info  */}
              {accessChecker("order_info") > -1 ||
                authInfo.role == "super_admin" ? (
                <Link
                  to="/administration/order-info"
                  className={classes.linkStyle}
                >
                  <ListItem button key="PermDataSettingIcon">
                    <ListItemText primary={"Order Info"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}


              {/* deliver info */}
              {accessChecker("delivery_info") > -1 ? (
                <Link
                  to="/administration/delivery-info"
                  className={classes.linkStyle}
                >
                  <ListItem button key="PermDataSettingIcon">
                    <ListItemText primary={"Delivery Info"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}
              {accessChecker("delivery_info") > -1 ? (
                <Link
                  to="/administration/create-crm-customer"
                  className={classes.linkStyle}
                >
                  <ListItem button key="PermDataSettingIcon">
                    <ListItemText primary={"Create CRM Customer"} />
                  </ListItem>
                </Link>
              ) : (
                ""
              )}

            </Fragment>
          ) : (
            ""
          )}

        </List>
      </Drawer>

      {/* Switch Branch  Modal */}
      <Modal
        open={branchSwitch}
        onClose={() => branchSwitchSet(false)}
        center
        style={{ minWidth: "300px", minHeight: "500px" }}
      >
        <Grid item xs={12} sm={12}>
          <Autocomplete
            style={{ width: "100%", padding: "10px" }}
            options={branches}
            size="small"
            getOptionLabel={(option) => option.branch_name}
            value={selectedBranch}
            onChange={(event, selectedObj) => {
              selectedBranchSet(selectedObj);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                type="text"
                autoComplete="off"
                label="Switch a Branch"
                variant="outlined"
                inputProps={{
                  ...params.inputProps,
                  endAdornment: (
                    <React.Fragment>
                      {/* {areas.length==0 ? <CircularProgress color="inherit" size={20} /> : null}
                            {params.InputProps.endAdornment} */}
                    </React.Fragment>
                  ),
                }}
              />
            )}
          />

          <Grid
            item
            xs={12}
            sm={12}
            style={{ marginTop: "6px", marginLeft: "10px" }}
          >
            <TextField
              type="text"
              autoComplete="off"
              className={classes.fullWidth}
              value={user_password}
              label="Enter your  password"
              name="user_password"
              style={{ color: "#222" }}
              variant="outlined"
              size="small"
              onChange={(e) => user_password_set(e.target.value)}
            />
          </Grid>

          <Button
            style={{ marginTop: "25px" }}
            variant="contained"
            color="primary"
            size="small"
            className={classes.button}
            startIcon={<SaveIcon />}
            onClick={() => actionToSwitch()}
          >
            Switch To Branch
          </Button>
        </Grid>
      </Modal>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    currentRoute: state.currentRouteReducer,
    authInfo: state.authInfoReducer,
  };
}
export default connect(mapStateToProps, {
  currentRouteSet,
  updatedCategorySet,
  createdCategorySet,
  disableRestoreSet,
  createdBrandSet,
  updatedBrandSet,
  brandDisableRestoreSet,
  createdFloorSet,
  updatedFloorSet,
  disableRestoreFloorSet,
  createdRackSet,
  updatedRackSet,
  disableRestoreRackSet,
  createdColorSet,
  updatedColorSet,
  disableRestoreColorSet,
  createdUnitSet,
  updatedUnitSet,
  disableRestoreUnitSet,
  createdBranchSet,
  updatedBranchSet,
  disableRestoreBranchSet,
  createdWarehouseSet,
  updatedWarehouseSet,
  disableRestoreWarehouseSet,
  createdAreaSet,
  updatedAreaSet,
  disableRestoreAreaSet,

  createdProdNameSet,
  updatedProdNameSet,
  disableRestoreProdNameSet,


  createdTransportNameSet,
  updatedTransportNameSet,
  disableRestoreTransportNameSet,

  createdDeliveryNameSet,
  updatedDeliveryNameSet,
  disableRestoreDeliveryNameSet,

  createdEmailCcNameSet,
  updatedEmailCcNameSet,
  disableRestoreEmailCcNameSet,

  createdDeliverySet,
  updatedDeliverySet,
  disableRestoreDeliverySet,

  createdProductSet,
  updatedProductSet,
  productCodeSet,
  disableRestoreProductSet,
  customerCodeSet,
  createdCustomerSet,
  updatedCustomerSet,
  disableRestoreCustomerSet,
  createdSupplierSet,
  updatedSupplierSet,
  disableRestoreSupplierSet,
  createdDesignationSet,
  updatedDesignationSet,
  disableRestoreDesignationSet,
  createdDepartmentSet,
  updatedDepartmentSet,
  disableRestoreDepartmentSet,
  createdMonthSet,
  updatedMonthSet,
  disableRestoreMonthSet,
  createdEmployeeSet,
  updatedEmployeeSet,
  employeeDisableRestoreSet,
  employeeCodeSet,
  createdTranAccSet,
  updatedTranAccSet,
  tranAccDisableRestoreSet,
  tranAccCodeSet,
  createdBankAccSet,
  bankAccCodeSet,
  updatedBankAccSet,
  createdCashTranSet,
  updatedCashTranSet,
  cashTranDisableRestoreSet,
  cashTranCodeSet,
  createdBankTranSet,
  updatedBankTranSet,
  bankTranDisableRestoreSet,
  bankTranCodeSet,
  createdCustomerPaySet,
  updatedCustomerPaySet,
  customerPayDisableRestoreSet,
  createdSupplierPaySet,
  updatedSupplierPaySet,
  supplierPayDisableRestoreSet,
  createdMaterialNameSet,
  updatedMaterialNameSet,
  disableRestoreMaterialNameSet,
  createdMaterialSet,
  updatedMaterialSet,
  materialCodeSet,
  disableRestoreMaterialSet,
})(Header);
